import { Component, OnInit } from '@angular/core';
import { FeatureService } from '@netfoundry-ui/shared/services';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {

    isCloudZiti;

    constructor(public featureService: FeatureService) {

    }

    ngOnInit(): void {
       this.isCloudZiti =  this.featureService.isCloudZiti;
    }
}
